export default __webpack_public_path__ + "static/media/cross.af3f431a.svg";